import { Switch } from "react-router";
import { isOutageWindow } from "../../adapters/utils";
import { OutageWindow } from "../../routes/outage-window";

export function ProtectedSwitch({ children }) {

    const {
        PPA_OUTAGE_NOTIFICATION_DISPLAY,
        PPA_OUTAGE_NOTIFICATION_START_TIME,
        PPA_OUTAGE_NOTIFICATION_END_TIME
    } = window.appConfig || {};
    const outageWindowActive = (
        PPA_OUTAGE_NOTIFICATION_DISPLAY === 'true'
        && isOutageWindow(
            PPA_OUTAGE_NOTIFICATION_START_TIME,
            PPA_OUTAGE_NOTIFICATION_END_TIME
        )
    );

    if (outageWindowActive) {
        return <OutageWindow />;
    }
    return <Switch children={children} />;
}